var url_path = window.location.pathname;

if (url_path == '/products' || url_path == '/products/'){
  window.location.href = "/collections/all";
}

function addToCartEventFB(){
  if (typeof fbq === 'function') fbq('track', 'AddToCart');
}

$(window).on('load', function() {

    // -------- Klavyio form submit + FB lead
    window.addEventListener("klaviyoForms", function(e) {
        if (e.detail.type == 'submit' && typeof fbq === 'function') {
            fbq('track', 'Lead');
        }
    });


    /* ---- prefix PageFly links with the active Shopify locale ---- */
    var localeMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/);
    if (localeMatch) {
        var locale = localeMatch[1];

        // add/remove segments here as needed
        var segments = ['products', 'pages', 'collections'];
        var segRe = segments.join('|');

        $('a[href*="/"]').filter(function () {
            return new RegExp('/(' + segRe + ')/').test($(this).attr('href') || '');

        }).each(function () {
            var href = $(this).attr('href');
            // skip if already localized

            if (new RegExp('^(https?:\\/\\/[^\\/]+)?\\/' + locale + '\\/').test(href)) return;

            $(this).attr('href', href.replace(
                new RegExp('(^(?:https?:\\/\\/[^\\/]+)?)\\/(' + segRe + ')\\/'),
                '$1/' + locale + '/$2/'
            ));
        });
    }



});


/* ---- Brand mark ®: United States only (2026-10-07) ----
   Source text everywhere on the site is plain "OrthoFlexx". For visitors in the United States market this script
   renders every "OrthoFlexx" in page text as OrthoFlexx<sup class="of-reg">®</sup> (styling: custom.css, sup.of-reg).
   For every other visitor it adds nothing, and removes a stray ® after "OrthoFlexx" if one slips in from an app
   or old content, so the mark never shows outside the US.
   Country comes from data-country on <html> (layout/theme.liquid writes localization.country.iso_code, i.e. the
   Shopify market the visitor is in), with Shopify.country as fallback. No geolocation request, no flicker.
   Runs on the body text only. Skips scripts, styles, form fields, editable areas, mailto links, text that already
   has a <sup>, and quoted text written by other people: customer reviews and the podiatrist endorsement
   (NO_REG_SELECTOR and NO_REG_CLASS). Add data-no-reg to any element to keep its text untouched.
   A page can opt out completely: if any element on it has data-no-reg-page, nothing is changed
   (used by third-person advertorials, e.g. sections/of-compare-article.liquid). */
(function () {
  var MARK_COUNTRIES = { US: 1 };
  var RE = /Ortho[Ff]lexx(?:\s?®)?/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, SUP: 1, SVG: 1, TITLE: 1, CODE: 1, PRE: 1, BLOCKQUOTE: 1, Q: 1 };

  /* review cards and the doctor's quote: text other people wrote is left as they wrote it */
  var NO_REG_SELECTOR = [
    '[data-no-reg]',
    '.cw-rev__card',            // reviews carousel (cw-pdp-reviews)
    '.cw-pdp-rv-card',          // review card under the product images
    '.cw-endorsement-section',  // podiatrist endorsement (cw-pdp-author)
    '.kl6-reviews-box',         // reviews slider in the empty cart
    '.qz__quote',               // review under the quiz
    '.cw-tmt-review-sec',       // older testimonials section
    '.cw-support-reviews'       // review rows in the pain / steps sections
  ].join(',');
  /* catches review and testimonial blocks in other sections by their class names */
  var NO_REG_CLASS = /(^|[\s_-])(review|reviews|testimonial|testimonials|endorsement|quote)([\s_-]|$)/i;

  function visitorCountry() {
    var fromTheme = document.documentElement.getAttribute('data-country');
    var fromShopify = window.Shopify && window.Shopify.country;
    return String(fromTheme || fromShopify || '').toUpperCase();
  }
  var addMark = !!MARK_COUNTRIES[visitorCountry()];

  /* whole page opted out */
  function pageOptedOut() {
    return !!document.querySelector('[data-no-reg-page]');
  }

  function skip(el) {
    for (var e = el; e && e !== document.body; e = e.parentElement) {
      if (SKIP[e.tagName]) return true;
      if (e.isContentEditable) return true;
      if (e.tagName === 'A' && /^mailto:/i.test(e.getAttribute('href') || '')) return true;
      if (e.matches && e.matches(NO_REG_SELECTOR)) return true;
      if (typeof e.className === 'string' && NO_REG_CLASS.test(e.className)) return true;
    }
    return false;
  }

  function isRegSup(node) {
    return node && node.nodeType === 1 && node.tagName === 'SUP' && /^\s*®\s*$/.test(node.textContent);
  }

  /* US: "OrthoFlexx" -> OrthoFlexx<sup class="of-reg">®</sup> */
  function addMarks(node) {
    var text = node.nodeValue;
    /* a name already followed by a <sup>®</sup> written in the source keeps that one */
    var keepLast = /Ortho[Ff]lexx\s?$/.test(text) && isRegSup(node.nextSibling);

    var frag = document.createDocumentFragment();
    var last = 0, m;
    RE.lastIndex = 0;
    while ((m = RE.exec(text))) {
      if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      frag.appendChild(document.createTextNode('OrthoFlexx'));
      last = m.index + m[0].length;
      if (keepLast && last === text.length) break;
      var sup = document.createElement('sup');
      sup.className = 'of-reg';
      sup.textContent = '®';
      frag.appendChild(sup);
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }

  /* everyone else: "OrthoFlexx®" -> "OrthoFlexx", and drop a <sup>®</sup> that follows the name */
  function removeMarks(node) {
    var text = node.nodeValue;
    if (/Ortho[Ff]lexx\s?$/.test(text) && isRegSup(node.nextSibling)) {
      node.nextSibling.parentNode.removeChild(node.nextSibling);
    }
    if (text.indexOf('®') === -1) return;
    node.nodeValue = text.replace(/(Ortho[Ff]lexx)\s?®/g, '$1');
  }

  function fix(root) {
    if (!root || pageOptedOut()) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [], n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf('rtho') !== -1 && RE.test(n.nodeValue)) nodes.push(n);
      RE.lastIndex = 0;
    }
    nodes.forEach(function (node) {
      if (!node.parentNode || skip(node.parentElement)) return;
      if (addMark) addMarks(node); else removeMarks(node);
    });
  }

  function run() { fix(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

  /* content the theme editor or cart drawer re-renders later */
  document.addEventListener('shopify:section:load', function (e) { fix(e.target); });
})();
